import {
  MenuItem,
  MenuList,
  MenuPopover,
  Menu,
  MenuTrigger,
} from '@fluentui/react-components';
import { MoreHorizontalIcon } from './FileOptionsPopover.styled';
import {
  ArrowDownloadRegular,
  ArrowDownloadFilled,
  bundleIcon,
} from '@fluentui/react-icons';
import axios from 'axios';
import { saveAs } from 'file-saver';

interface FileOptionsPopoverProps {
  file: File;
  annotationID: string;
}

export const FileOptionsPopover = ({
  file,
  annotationID,
}: FileOptionsPopoverProps) => {
  const DownloadIcon = bundleIcon(ArrowDownloadRegular, ArrowDownloadFilled);

  const handleDownload = () => {
    axios
      .get(`api/annotations/files/${annotationID}`, { responseType: 'blob' })
      .then((response) => response.data)
      .then((data) => {
        const fileToDownload = new File([data], file.name, { type: file.type });
        saveAs(fileToDownload, file.name);
      })
      .catch((error) => console.log(error));
  };

  return (
    <Menu>
      <MenuTrigger>
        <MoreHorizontalIcon />
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <MenuItem icon={<DownloadIcon />} onClick={handleDownload}>
            Download
          </MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
